<template>
	<header>
        <span v-if="showSearch">
            <SearchComp :options="data.searchOption"></SearchComp>
        </span>
		<slot name="header"></slot>
	</header>
	<main style="margin: 10px 0">
		<slot name="main" />
	</main>
	<PageComp
		v-if="showPage"
		:total="total"
		:currentPage="currentPage"
		:pageSize="pageSize"
		@handleSizeChange="handleSizeChange"
		@handleCurrentChange="handleCurrentChange"
	></PageComp>
</template>

<script>
import { computed, provide, reactive, toRaw } from "vue";
import { usePage } from "@/api/use.js";
export default {
	name: "MainTempComp",
	props: {
		showSearch: {
			type: Boolean,
			default: true,
		},
		showPage: {
			type: Boolean,
			default: true,
		},
		searchOption: {
			type: Object,
			default() {
				return {};
			},
		},
		handleSearch: {
			type: Function,
			require: true,
		},
	},
	setup(props) {
		var {
			total,
			currentPage,
			pageSize,
			handleSizeChange,
			handleCurrentChange,
		} = usePage(props.handleSearch);

		const setTotalValue = (val) => {
			total.value = val;
		};
		const setPageValue = (val) => {
			currentPage.value = val;
		};

		const data = reactive({
			searchOption: props.searchOption,
		});

		const searchParams = computed(() => {
			let params = {};
			data.searchOption.forEach((item) => {
				const config = {
					datePicker() {
						params[item.paramsKey.start_time] =
							item.value && item.value.length
								? item.value[0]
								: "";
						params[item.paramsKey.end_time] =
							item.value && item.value.length
								? item.value[1]
								: "";
					},
					input() {
						params[item.key] = item.value;
					},
					select() {
						params[item.key] = item.value;
					},
					searchAddress() {
						console.log("item.value:", item.value);
						params[item.key] = item.value;
					},
				};
				config[item.type] && config[item.type]();
			});
			return params;
		});

		const updateSearchOption = (key, val) => {
			const obj = data.searchOption.find((item) => item.key === key);
            console.log('obj:',obj,val);
			if (obj) {
				obj.value = val;
			}
		};
		provide("updateSearchOption", updateSearchOption);
		return {
			setPageValue,
			setTotalValue,
			searchParams,
			data,
			handleSearch: props.handleSearch,
			handleSizeChange,
			handleCurrentChange,
			total,
			currentPage,
			pageSize,
		};
	},
};
</script>

<style scoped>
</style>
